import { StatusEnum } from "./status-enum";

export const statusColors = {
  [StatusEnum.ACTIVE]: "success",
  [StatusEnum.INACTIVE]: "default",
};
